module.exports = __webpack_public_path__ + "img/pingtai2.6d85f4c4.png";